module.exports = __webpack_public_path__ + "img/Frame-58.646b4585.svg";